<script lang="ts" setup>
import { zClient } from '@/services/zafClient';

import { onBeforeMount } from 'vue';

onBeforeMount(() => {
  if (zClient) {
    zClient.invoke('resize', { width: '100%', height: '775px' });
  }
});
</script>

<template>
  <router-view />
</template>

<style scoped></style>
